import { defineStore } from 'pinia';
import { IClaim } from "@cyber-range/cyber-range-api-entitlement-client";
import { useApiClientStore } from './apiClientStore';

function getClaimId(type, value, scope)
{
    return `${scope || ''}::${type || ''}::${value || ''}`;
}

export const useEntitlementStore = defineStore('entitlementStore', {
    state: () => ({
        claims: {},
        scopes: []
    }),
    getters: {
        hasClaim: (state) => (type:string, valueOrValues:string|string[], scopeOrScopes:string|string[]):boolean => {

            let values = Array.isArray(valueOrValues) ? [...new Set(valueOrValues)] : [valueOrValues];
            let scopes = Array.isArray(scopeOrScopes) ? [...new Set(scopeOrScopes)] : [scopeOrScopes];

            for(let value of values)
            {
                for(let scope of scopes)
                {
                    let key = getClaimId(type, value, scope);
                    if(key in state.claims)
                    {
                        return true;
                    }
                }
            }

            return false;
        },
        getClaim: (state) => (type:string, valueOrValues:string|string[], scopeOrScopes:string|string[]):IClaim[] => {
            let result = [];
            let table = {};
            let values = valueOrValues === undefined ? Object.values(state.claims).map((claim:IClaim) => claim.value):
                                            (Array.isArray(valueOrValues)?
                                            [...new Set(valueOrValues)] : [valueOrValues]);
            let scopes = Array.isArray(scopeOrScopes) ? [...new Set(scopeOrScopes)] : [scopeOrScopes];

                for(let value of values)
                {
                    for(let scope of scopes)
                    {
                        let key = getClaimId(type, value, scope);
                        if(key in state.claims && !(key in table))
                        {
                            result.push(state.claims[key]);
                            table[key] = true;
                        }
                    }
                }

            return result;
        },
        getClaims: (state) => (type:string):IClaim[] => {
            return Object.values(state.claims).filter(claim => claim.type === type);
        },
    },
    actions: {
        async fetchClaims() {
            let claims:IClaim[] = await useApiClientStore().entitlementApiClient.listClaims();
            this.claims = {};
            let scopes = new Set<string>();
            for(let claim of claims)
            {
                for(let scope of claim.scopes)
                {
                    scopes.add(scope);
                    this.claims[getClaimId(claim.type, claim.value, scope)] = claim;
                }
            }
            this.scopes = [...scopes];
        },
        clearClaims() {
            this.claims = {};
            this.scopes = [];
        }
    }
});
